import {
CheckCircle,
Cancel,
} from '@mui/icons-material';

export const recordsPerPage = 20;

export const getImageUrl = (API, ImageName) => {
    if (!API || !ImageName) {
        return null;
    }
    // If ImageName is just a filename or relative path
    return `${API}${ImageName}`;
};





export const getInitials = (name) => {
    if (!name) return '??';
    
    const words = name.split(' ').filter(word => word.length > 0);
    
    if (words.length === 0) return '??';
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

export const formatNumberWithComma = (numb) => {
    // Convert to number first
    const num = Number(numb);
    
    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return  "Sh"+" "+str.join(".");
};
export const recordsCount = (numb) => {
    // Convert to number first
    const num = Number(numb);

    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};
export const formatCreatedAtDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',    // "Mar"
        day: '2-digit',   // "02"
        year: 'numeric'    // "2025"
    });
};




export const statusData =[
    {id:1,name:"Active"},
    {id:2,name:"Not-Active"},

];

export const getStatusById = (id) => {
    let Id = parseInt(id) ;
    const status = statusData.find(item => item.id === Id);
    return status?.name || "Un-known"
};


export const getNameById = (id, Data) => {
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        nameFound = record.name
    } else {
        return "No Record Found";
    }

    return nameFound;
};


export const getUserDetails = (request) => {
    try {
        const userString = sessionStorage.getItem("userInfo");
        if (!userString) {
            console.warn("No user details found in session storage");
            return null;
        }
        
        const user = JSON.parse(userString);
        if (!user) {
            console.warn("User details are empty");
            return null;
        }

        const role = user.role || user.user_type || "";
        const Id = user.id || "";
        const user_type = user.user_type || "";
        const user_contact = user.contact_phone || "";
        const nationality = user.nationality || "";
        const user_name = user.full_name || user.name || "";
        const supervisor_id = user.supervisor_id || 0;
        const email = user.email || "";
        const university = user.university || "";
        const university_id = user.university_id || "";
        const registration_id = user.registration_id || "";
        const profile_image_url = user.profile_image_path || "";
        const is_verified = user.is_verified || false;
        const academic_title = user.academic_title || "";
        const admin_id_number = user.admin_id_number || "";

        switch (request) {
            case "roleId":
                return role;
            case "Id":
                return parseInt(Id);
            case "profile":
                return user;
            case "user_type":
                return user_type;
            case "userName":
                return user_name;
            case "contact":
                return user_contact;
            case "email":
                return email;
            case "university":
                return university;
            case "universityId":
                return university_id;
                case "registrationId":
                return registration_id;
            case "profileImage":
                return profile_image_url;
            case "is_verified":
                return is_verified;
            case "academicTitle":
                return academic_title;
            case "admin_id_number":
                return admin_id_number;
            case "supervisorId":
                return supervisor_id;
            case "nationality":
                return nationality;
            default:
                console.warn(`Invalid request parameter: ${request}`);
                return null;
        }
    } catch (error) {
        console.error("Error in getUserDetails:", error.message);
        return null;
    }
}
const currentUserId = getUserDetails("Id");
const currentUserType = getUserDetails("user_type");
export const isStudent = currentUserType === 'student';
export const isSupervisor = currentUserType === 'supervisor';
export const isAdmin = currentUserType === 'university_admin';


/**
 * Get user display information in a formatted object
 * 
 */
export const getUserDisplayInfo = () => {
    try {
        const userString = sessionStorage.getItem("userInfo");
        if (!userString) {
            return {
                id: null,
                name: 'User',
                email: '',
                role: 'student',
                avatar: null
            };
        }
        
        const user = JSON.parse(userString);
        
        return {
            id: user.id || null,
            name: user.full_name || user.name || 'User',
            email: user.email || '',
            role: user.user_type || user.role || 'student',
            avatar: user.profile_image_url || null,
            registration_id: user.registration_id || null,
            university: user.university || null,
            is_verified: user.is_verified || false
        };
    } catch (error) {
        console.error("Error in getUserDisplayInfo:", error.message);
        return {
            id: null,
            name: 'User',
            email: '',
            role: 'student',
            avatar: null
        };
    }
};



// notifications 
export const formatDateTime = (dateString) => {
    try {
        const date = new Date(dateString);
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return date.toLocaleDateString('en-US', options);
    } catch {
        return dateString;
    }
};


// Custom date formatting function
export const formatDate = (dateString) => {
    try {
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'Just now';
        if (diffMins < 60) return `${diffMins} min ago`;
        if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
        if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
        
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    } catch {
        return dateString;
    }
};


export const formatTableDate = (dateString) => {
    try {
        const date = new Date(dateString);
        const options = { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return date.toLocaleDateString('en-US', options);
    } catch {
        return dateString;
    }
};